import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import environment from '@environments/environment';
import { EmptyInterface } from '@interfaces/core/model.interface';
import { HttpClientFetcher } from '@services/htttp-client-fetcher.service';
import { ApiHttpConfig } from '@shared/config/api-http.config';
import { firstValueFrom } from 'rxjs';

import { TranslationResponseDTO } from '../interfaces/translations-response-dto.interface';

const { apiAdminUrl } = environment;

@Injectable()
export class AsyncTranslationsFinderFetcher extends HttpClientFetcher<
  TranslationResponseDTO[],
  EmptyInterface
> {
  public async run(
    accessToken: string,
    language: string = 'es-es',
  ): Promise<HttpResponse<TranslationResponseDTO[]>> {
    const url = `${apiAdminUrl}/literals/all?language=${language}`;
    const options = ApiHttpConfig.createWithBearer(accessToken);

    return firstValueFrom(this.findAll(url, options));
  }
}
